import styled from "styled-components";
import { faCircleCheck as faCheck } from "@fortawesome/free-solid-svg-icons";

import {
  faCar,
  faCogs,
  faTachometerAlt,
  faRoad,
  faPalette,
  faPaintRoller,
  faGasPump,
  faHashtag,
  faIdCard,
  faSlidersH,
  faLayerGroup,
  faListAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SpecsWrapper = styled.div`
  color: #333;
`;

const SpecsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
`;

const SectionHeader = styled.div`
  font-size: 24px;
  font-family: var(--font-semiBold);
  margin: 40px 0 0px;
  background: #f0f0f0;
  padding: 16px 20px 8px;
  border-radius: 20px 20px 0 0;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
  text-align: left;
  color: #333;
`;

const SpecsGrids = styled.div`
  background: white;
  gap: 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  margin: 40px 0;

  .poll {
    background: #f0f0f0;
    padding: 16px 20px;
    border-bottom: 1px solid #ddd;
    font-family: var(--font-semiBold);
    border-radius: 20px 20px 0 0;
    font-size: 24px;
  }

  .aslam {
    padding: 20px;
  }
`;

const SpecItem = styled.div`
  font-size: 16px;
  background: #f9f9f9;
  padding: 16px;
  border-bottom: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  gap: 12px;
`;

const IconWrapper = styled.div`
  color: #555;
  justify-content:start;
  align-items:start;
height:100%;
  font-size: 20px;
  min-width: 20px;
`;

const Kala = styled.div`
  font-family: var(--font-semiBold);
  margin-bottom: 6px;
  font-size: 14px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const FeatureSection = styled.div`
  margin-bottom: 40px;
`;

const FeatureHeader = styled.div`
  font-size: 20px;
  font-weight: bold;
  font-family: var(--font-medium);
  background: #f0f0f0;
  padding: 16px 20px;
  border-radius: 20px 20px 0 0;
  border-bottom: 1px solid #ddd;
`;

const FeatureList = styled.div`
  background: white;
  border-radius: 0 0 20px 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

const FeatureItem = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: flex-start;
  gap: 8px;

  &::before {
    content: "";
    width: 16px;
    height: 16px;
    background-image: url('/tick-icon.png'); // Replace with your actual tick icon path
    background-size: contain;
    background-repeat: no-repeat;
    margin-top: 2px;
    flex-shrink: 0;
  }

  .icon {
    color: #555;
    margin-top: 3px;
    font-size: 16px;
    flex-shrink: 0;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const VehicleSpecs = ({ vehicle }: { vehicle: any }) => {
  const technology = vehicle.technologyOptions || [];
  const condition = vehicle.conditionOptions || [];

  const convenience =
    Array.isArray(vehicle.convenienceOptions) && vehicle.convenienceOptions || [];
  const highValue = vehicle.highValueOptions || [];

  return (
    <SpecsWrapper>
      <SpecsGrids>
        <div className="poll">
          {vehicle.year} {vehicle.make} {vehicle.model} {vehicle.trim} Specifications
        </div>
        <div className="aslam">
          <SpecsGrid>
            {vehicle.make && (
              <SpecItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faCar} />
                </IconWrapper>
                <TextWrapper>
                  <Kala>Make</Kala>
                  {vehicle.make}
                </TextWrapper>
              </SpecItem>
            )}
            {vehicle.model && (
              <SpecItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faLayerGroup} />
                </IconWrapper>
                <TextWrapper>
                  <Kala>Model</Kala>
                  {vehicle.model}
                </TextWrapper>
              </SpecItem>
            )}
            {vehicle.trim && (
              <SpecItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faSlidersH} />
                </IconWrapper>
                <TextWrapper>
                  <Kala>Trim</Kala>
                  {vehicle.trim}
                </TextWrapper>
              </SpecItem>
            )}
            {vehicle.km && (
              <SpecItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faTachometerAlt} />
                </IconWrapper>
                <TextWrapper>
                  <Kala>Mileage (KM)</Kala>
                  {Number(vehicle.km).toLocaleString()} km
                </TextWrapper>
              </SpecItem>
            )}
         

               {vehicle.transmission && (
              <SpecItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faCogs} />
                </IconWrapper>
                <TextWrapper>
                  <Kala>Transmission</Kala>
                  {vehicle.transmission}
                </TextWrapper>
              </SpecItem>
            )}
            {(vehicle.convenienceOptions?.drivetrain || vehicle.drivetrain) && (
              <SpecItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faRoad} />
                </IconWrapper>
                <TextWrapper>
                  <Kala>Drivetrain</Kala>
                  {vehicle.convenienceOptions?.drivetrain || vehicle.drivetrain}
                </TextWrapper>
              </SpecItem>
            )}
            {(vehicle.convenienceOptions?.extColor || vehicle.extColor) && (
              <SpecItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faPalette} />
                </IconWrapper>
                <TextWrapper>
                  <Kala>Exterior</Kala>
                  {vehicle.convenienceOptions?.extColor || vehicle.extColor}
                </TextWrapper>
              </SpecItem>
            )}
            {(vehicle.convenienceOptions?.interiorColor ||
              vehicle.interiorColor) && (
              <SpecItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faPaintRoller} />
                </IconWrapper>
                <TextWrapper>
                  <Kala>Interior</Kala>
                  {vehicle.convenienceOptions?.interiorColor ||
                    vehicle.interiorColor}
                </TextWrapper>
              </SpecItem>
            )}
            {vehicle.engine && (
              <SpecItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faGasPump} />
                </IconWrapper>
                <TextWrapper>
                  <Kala>Engine</Kala>
                  {vehicle.engine}
                </TextWrapper>
              </SpecItem>
            )}
            {vehicle.stock && (
              <SpecItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faHashtag} />
                </IconWrapper>
                <TextWrapper>
                  <Kala>Stock</Kala>
                  {vehicle.stock}
                </TextWrapper>
              </SpecItem>
            )}
            {(vehicle.VIN || vehicle.vin) && (
              <SpecItem>
                <IconWrapper>
                  <FontAwesomeIcon icon={faIdCard} />
                </IconWrapper>
                <TextWrapper>
                  <Kala>VIN</Kala>
                  {vehicle.VIN || vehicle.vin}
                </TextWrapper>
              </SpecItem>
            )}
          </SpecsGrid>
        </div>
      </SpecsGrids>

      {technology.length > 0 && (
        <FeatureSection>
          <FeatureHeader>Technology Features</FeatureHeader>
          <FeatureList>
            {technology.map((item: string, idx: number) => (
              <FeatureItem key={`tech-${idx}`}>
                          <FontAwesomeIcon icon={faCheck} className="icon" />
{item}</FeatureItem>
            ))}
          </FeatureList>
        </FeatureSection>
      )}

      {convenience.length > 0 && (
        <FeatureSection>
          <FeatureHeader>Convenience Features</FeatureHeader>
          <FeatureList>
            {convenience.map((item: string, idx: number) => (
              <FeatureItem key={`conv-${idx}`}>
                          <FontAwesomeIcon icon={faCheck} className="icon" />
{item}</FeatureItem>
            ))}
          </FeatureList>
        </FeatureSection>
      )}

{condition.length > 0 && (
        <FeatureSection>
          <FeatureHeader>Condition & Protection Options</FeatureHeader>
          <FeatureList>
            {condition.map((item: string, idx: number) => (
              <FeatureItem key={`conv-${idx}`}>
                          <FontAwesomeIcon icon={faCheck} className="icon" />
{item}</FeatureItem>
            ))}
          </FeatureList>
        </FeatureSection>
      )}

      {highValue.length > 0 && (
        <FeatureSection>
          <FeatureHeader>High Value Options</FeatureHeader>
          <FeatureList>
            {highValue.map((item: string, idx: number) => (
              
              <FeatureItem key={`high-${idx}`}>
                          <FontAwesomeIcon icon={faCheck} className="icon" />
{item}</FeatureItem>
            ))}
          </FeatureList>
        </FeatureSection>
      )}
    </SpecsWrapper>
  );
};

export default VehicleSpecs;
